var _linearGradient, _linearGradient2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClickupIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 155,
    viewBox: "0 0 130 155",
    width: 130,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clickup-icon_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4,
    x2: 129.43,
    y1: 137.687,
    y2: 137.687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8930fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49ccf9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "clickup-icon_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 3.21,
    x2: 126.84,
    y1: 51.984,
    y2: 51.984
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff02f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc800"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.4 119.12l23.81-18.24C36.86 117.39 50.3 125 65.26 125c14.88 0 27.94-7.52 40.02-23.9l24.15 17.8C112 142.52 90.34 155 65.26 155c-25 0-46.87-12.4-64.86-35.88z",
    fill: "url(#clickup-icon_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.18 39.84L22.8 76.36 3.21 53.64 65.27.16l61.57 53.52-19.68 22.64z",
    fill: "url(#clickup-icon_svg__b)"
  })));
}
export default SvgClickupIcon;